// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://www.nubeufs.com/api',
  clientBaseURL: 'https://www.nubeufs.com/pack',
  rollbarToken: 'de9b2b7a16a54971a55250d3274e53309fbe6d1a4dcaaea26e86344743fd3166ed532e8dcf30cd20ff9e06365eb7b2c4',
  clarityProjectId: 'vbmv0wm353',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
